interface CurrencyMap {
  [key: string]: string;
}

export const basicCurrencies: CurrencyMap = {
  PKR: 'Pakistani Rupee',
  USD: 'US Dollar',
  EUR: 'Euro',
  AED: 'United Arab Emirates Dirham',
  GBP: 'British Pound Sterling',
  INR: 'Indian Rupee',
};

export const basicCurrenciesList = Object.entries(basicCurrencies);

export const allCurrencies: CurrencyMap = {
  AFN: 'Afghanistan Afghani',
  ALL: 'Albanian Lek',
  DZD: 'Algerian Dinar',
  AOA: 'Angolan Kwanza',
  ARS: 'Argentine Peso',
  AMD: 'Armenian Dram',
  AWG: 'Aruban Florin',
  AUD: 'Australian Dollar',
  AZN: 'Azerbaijani Manat',
  BSD: 'Bahamian Dollar',
  BHD: 'Bahraini Dinar',
  BDT: 'Bangladeshi Taka',
  BBD: 'Barbadian Dollar',
  BYR: 'Belarusian Ruble',
  BEF: 'Belgian Franc',
  BZD: 'Belize Dollar',
  BMD: 'Bermudan Dollar',
  BTN: 'Bhutanese Ngultrum',
  BTC: 'Bitcoin',
  BOB: 'Bolivian Boliviano',
  BAM: 'Bosnia-Herzegovina Convertible Mark',
  BWP: 'Botswanan Pula',
  BRL: 'Brazilian Real',
  // GBP: "British Pound Sterling",
  BND: 'Brunei Dollar',
  BGN: 'Bulgarian Lev',
  BIF: 'Burundian Franc',
  KHR: 'Cambodian Riel',
  CAD: 'Canadian Dollar',
  CVE: 'Cape Verdean Escudo',
  KYD: 'Cayman Islands Dollar',
  // XOF: 'CFA Franc BCEAO',
  // XAF: 'CFA Franc BEAC',
  // XPF: 'CFP Franc',
  CLP: 'Chilean Peso',
  // CLF: 'Chilean Unit of Account',
  CNY: 'Chinese Yuan',
  COP: 'Colombian Peso',
  KMF: 'Comorian Franc',
  CDF: 'Congolese Franc',
  CRC: 'Costa Rican Colón',
  HRK: 'Croatian Kuna',
  CUC: 'Cuban Convertible Peso',
  CZK: 'Czech Republic Koruna',
  DKK: 'Danish Krone',
  DJF: 'Djiboutian Franc',
  DOP: 'Dominican Peso',
  XCD: 'East Caribbean Dollar',
  EGP: 'Egyptian Pound',
  ERN: 'Eritrean Nakfa',
  EEK: 'Estonian Kroon',
  ETB: 'Ethiopian Birr',
  // EUR: "Euro",
  FKP: 'Falkland Islands Pound',
  FJD: 'Fijian Dollar',
  GMD: 'Gambian Dalasi',
  GEL: 'Georgian Lari',
  DEM: 'German Mark',
  GHS: 'Ghanaian Cedi',
  GIP: 'Gibraltar Pound',
  GRD: 'Greek Drachma',
  GTQ: 'Guatemalan Quetzal',
  GNF: 'Guinean Franc',
  GYD: 'Guyanaese Dollar',
  HTG: 'Haitian Gourde',
  HNL: 'Honduran Lempira',
  HKD: 'Hong Kong Dollar',
  HUF: 'Hungarian Forint',
  ISK: 'Icelandic Króna',
  // INR: "Indian Rupee",
  IDR: 'Indonesian Rupiah',
  IRR: 'Iranian Rial',
  IQD: 'Iraqi Dinar',
  ILS: 'Israeli New Sheqel',
  ITL: 'Italian Lira',
  JMD: 'Jamaican Dollar',
  JPY: 'Japanese Yen',
  JOD: 'Jordanian Dinar',
  KZT: 'Kazakhstani Tenge',
  KES: 'Kenyan Shilling',
  KWD: 'Kuwaiti Dinar',
  KGS: 'Kyrgystani Som',
  LAK: 'Laotian Kip',
  LVL: 'Latvian Lats',
  LBP: 'Lebanese Pound',
  LSL: 'Lesotho Loti',
  LRD: 'Liberian Dollar',
  LYD: 'Libyan Dinar',
  LTC: 'Litecoin',
  LTL: 'Lithuanian Litas',
  MOP: 'Macanese Pataca',
  MKD: 'Macedonian Denar',
  MGA: 'Malagasy Ariary',
  MWK: 'Malawian Kwacha',
  MYR: 'Malaysian Ringgit',
  MVR: 'Maldivian Rufiyaa',
  MRO: 'Mauritanian Ouguiya',
  MUR: 'Mauritian Rupee',
  MXN: 'Mexican Peso',
  MDL: 'Moldovan Leu',
  MNT: 'Mongolian Tugrik',
  MAD: 'Moroccan Dirham',
  MZM: 'Mozambican Metical',
  MMK: 'Myanmar Kyat',
  NAD: 'Namibian Dollar',
  NPR: 'Nepalese Rupee',
  ANG: 'Netherlands Antillean Guilder',
  TWD: 'New Taiwan Dollar',
  NZD: 'New Zealand Dollar',
  NIO: 'Nicaraguan Córdoba',
  NGN: 'Nigerian Naira',
  KPW: 'North Korean Won',
  NOK: 'Norwegian Krone',
  OMR: 'Omani Rial',
  // PKR: "Pakistani Rupee",
  PAB: 'Panamanian Balboa',
  PGK: 'Papua New Guinean Kina',
  PYG: 'Paraguayan Guarani',
  PEN: 'Peruvian Nuevo Sol',
  PHP: 'Philippine Peso',
  PLN: 'Polish Zloty',
  QAR: 'Qatari Rial',
  RON: 'Romanian Leu',
  RUB: 'Russian Ruble',
  RWF: 'Rwandan Franc',
  SVC: 'Salvadoran Colón',
  WST: 'Samoan Tala',
  STD: 'São Tomé and Príncipe Dobra',
  SAR: 'Saudi Riyal',
  RSD: 'Serbian Dinar',
  SCR: 'Seychellois Rupee',
  SLL: 'Sierra Leonean Leone',
  SGD: 'Singapore Dollar',
  SKK: 'Slovak Koruna',
  SBD: 'Solomon Islands Dollar',
  SOS: 'Somali Shilling',
  ZAR: 'South African Rand',
  KRW: 'South Korean Won',
  SSP: 'South Sudanese Pound',
  XDR: 'Special Drawing Rights',
  LKR: 'Sri Lankan Rupee',
  SHP: 'St. Helena Pound',
  SDG: 'Sudanese Pound',
  SRD: 'Surinamese Dollar',
  SZL: 'Swazi Lilangeni',
  SEK: 'Swedish Krona',
  CHF: 'Swiss Franc',
  SYP: 'Syrian Pound',
  TJS: 'Tajikistani Somoni',
  TZS: 'Tanzanian Shilling',
  THB: 'Thai Baht',
  TOP: "Tongan Pa'anga",
  TTD: 'Trinidad & Tobago Dollar',
  TND: 'Tunisian Dinar',
  TRY: 'Turkish Lira',
  TMT: 'Turkmenistani Manat',
  UGX: 'Ugandan Shilling',
  UAH: 'Ukrainian Hryvnia',
  // AED: "United Arab Emirates Dirham",
  UYU: 'Uruguayan Peso',
  // USD: "US Dollar",
  // UZS: 'Uzbekistan Som',
  // VUV: 'Vanuatu Vatu',
  // VEF: 'Venezuelan BolÃvar',
  // VND: 'Vietnamese Dong',
  // YER: 'Yemeni Rial',
  // ZMK: 'Zambian Kwacha',
  ZWL: 'Zimbabwean dollar',
};
export const allCurrenciesList = Object.entries(allCurrencies);

export const currencyCodeToLocales: CurrencyMap = {
  AFN: 'ps-AF',
  ALL: 'sq-AL',
  DZD: 'kab-DZ',
  AOA: 'ln-AO',
  ARS: 'sq-AL',
  AMD: 'hy-AM',
  AWG: 'nl-AW',
  AUD: 'en-AU',
  AZN: 'az-Cyrl-AZ',
  BSD: 'en-BS',
  BHD: 'ar-BH',
  BDT: 'bn-BD',
  BBD: 'en-BB',
  BYR: 'ru-BY',
  BZD: 'en-BZ',
  BMD: 'en-BM',
  BTN: 'dz-BT',
  BOB: 'es-BO',
  BAM: 'bs-Cyrl-BA',
  BWP: 'en-BW',
  BRL: 'pt-BR',
  GBP: 'en-GB',
  BND: 'ms-Latn-BN',
  BGN: 'bg-BG',
  BIF: 'rn-BI',
  KHR: 'km-KH',
  CAD: 'fr-CA',
  CVE: 'pt-CV',
  KYD: 'en-KY',
  CLP: 'es-CL',
  CNY: 'ii-CN',
  COP: 'es-CO',
  KMF: 'ar-KM',
  CDF: 'lu-CD',
  CRC: 'es-CR',
  HRK: 'hr-HR',
  CZK: 'en-CZ',
  DKK: 'da-DK',
  DJF: 'ar-DJ',
  DOP: 'es-DO',
  EGP: 'ar-EG',
  ERN: 'ar-ER',
  ETB: 'om-ET',
  EUR: 'en-DE',
  FKP: 'en-FK',
  FJD: 'en-FJ',
  GMD: 'en-GM',
  GEL: 'ka-GE',
  GHS: 'ak-GH',
  GIP: 'en-GI',
  GTQ: 'es-GT',
  GNF: 'fr-GN',
  GYD: 'en-GY',
  HTG: 'fr-HT',
  HNL: 'es-HN',
  HKD: 'zh-Hans-HK',
  HUF: 'en-HU',
  ISK: 'en-IS',
  INR: 'en-IN', //"kok-IN",
  IDR: 'id-ID',
  IRR: 'fa-IR',
  IQD: 'ar-IQ',
  ILS: 'ar-IL',
  JMD: 'en-JM',
  JPY: 'ja-JP',
  JOD: 'ar-JO',
  KZT: 'kk-Cyrl-KZ',
  KES: 'saq-KE',
  KWD: 'ar-KW',
  KGS: 'ru-KG',
  LAK: 'lo-LA',
  LVL: 'en-LV',
  LBP: 'ar-LB',
  LSL: 'en-LS',
  LRD: 'vai-Latn-LR',
  LYD: 'ar-LY',
  LTL: 'en-LT',
  MOP: 'zh-Hant-MO',
  MKD: 'sq-MK',
  MGA: 'mg-MG',
  MWK: 'en-MW',
  MYR: 'ms-Latn-MY',
  MRO: 'ar-MR',
  MUR: 'en-MU',
  MXN: 'es-MX',
  MDL: 'ru-MD',
  MNT: 'mn-Cyrl-MN',
  MAD: 'ar-MA',
  MMK: 'my-MM',
  NAD: 'naq-NA',
  NPR: 'ne-NP',
  ANG: 'nl-CW',
  TWD: 'zh-Hant-TW',
  NZD: 'en-NZ',
  NIO: 'es-NI',
  NGN: 'ha-Latn-NG',
  KPW: 'ko-KP',
  NOK: 'nn-NO',
  OMR: 'ar-OM',
  PKR: 'en-IN', // "pa-Arab-PK", //"en-PK", //"pa-Arab-PK",
  PAB: 'es-PA',
  PGK: 'en-PG',
  PYG: 'es-PY',
  PEN: 'es-PE',
  PHP: 'es-PH',
  PLN: 'en-PL',
  QAR: 'ar-QA',

  RON: 'en-RO',
  RUB: 'ru-RU',
  RWF: 'rw-RW',

  WST: 'en-WS',
  STD: 'pt-ST',
  SAR: 'ar-SA',
  RSD: 'sr-Latn-RS',
  SCR: 'en-SC',

  SLL: 'en-SL',
  SGD: 'ms-Latn-SG',

  SBD: 'en-SB',
  SOS: 'ar-SO',
  ZAR: 'en-LS',
  KRW: 'ko-KR',

  LKR: 'ta-LK',
  SHP: 'en-SH',
  SDG: 'ar-SD',
  SRD: 'nl-SR',

  SZL: 'en-SZ',
  SEK: 'sv-SE',
  CHF: 'rm-CH',
  SYP: 'ar-SY',
  TJS: 'tg-Cyrl-TJ',
  TZS: 'sw-TZ',
  THB: 'th-TH',
  TOP: 'to-TO',

  TTD: 'en-TT',
  TND: 'ar-TN',
  TRY: 'tr-TR',
  TMT: 'tk-Latn-TM',

  UGX: 'teo-UG',
  UAH: 'ru-UA',
  AED: 'ar-AE',
  UYU: 'es-UY',
  USD: 'en-US', //-POSIX

  // UZS: 'uz-Cyrl-UZ',
  // VUV: 'en-VU',
  // VEF: 'es-VE',
  VND: 'vi-VN',
  // YER: 'ar-YE',
};

export const localesToCurrency: {
  [key: string]: string
} = {};

Object.entries(currencyCodeToLocales).forEach(([currencyCode, locale]) => {
  localesToCurrency[locale] = currencyCode;
});
